/* eslint-disable */
import { InputBase, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { useRef, useState } from 'react';

const useStyles = makeStyles({
  userMessage: {
    padding: '.625em 1.25em',
    borderRadius: '1.5em',
    backgroundColor: '#dee2e6',
    maxWidth: '70%',
    marginLeft: '30%',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
});

const UserMessage = ({ message = '' }) => {
  const classes = useStyles();

  return <div className={classes.userMessage}>{message}</div>;
};

export default UserMessage;
